import List from "@/components/list";
import router from "@/router";
import "./table.scss";

const Table = args => {

  const { listeners } = args;
  const showImage = listeners["showImage"] || function () { };

  function toDetail(item) {
    router.push({
      path: "liveData/info",
      query: {
        id: item.uuid,
      },
    });
  }

  const Deal = ({ props: { vo } }) => {
    let dealConf = [];
    dealConf.push(["iconfont icrenyuanxiangqing iconfont-adapt", "查看详情", () => toDetail(vo.row), "liveManage:branchDetailPage"])
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const Img = ({ props: { vo } }) => {
    return (
      <div onClick={() => showImage(vo.row)}>
        <img
          class='live-image'
          src={
            vo.row.coverUrl
          }
        />
      </div>
    );
  };

  const LecturerName = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <el-tooltip class="item" effect={"dark"} content={item.lecturerName} placement={"top"}>
          <div class="ellipsis--l2">{item.lecturerName}</div>
      </el-tooltip>
    );
  };

  const AccountTableConfig = [
    {
      label: "直播名称",
      minWidth: "200",
      showOverflowTooltip: true,
      prop: "name",
    },
    {
      label: "封面",
      width: "190",
      render: vo => <Img vo={vo} />
    },
    {
      label: "直播时间",
      prop: "startDateStr",
      minWidth: "100",
    },
    {
      label: "讲师",
      prop: "lecturerName",
      minWidth: "200",
      render: vo => <LecturerName vo={vo} />
    },
    {
      label: "直播学时",
      prop: "credit",
      minWidth: "60",
    },
    {
      label: "操作",
      width: "80",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];

  return (
    <div>
      <List
        {...args}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
